import { Component, OnInit } from '@angular/core';
import { FormBaseComponent } from '../../core/component/form-base/form-base.component';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-buro-form',
  templateUrl: './buro-form.component.html',
  styleUrls: ['./buro-form.component.scss']
})
export class BuroFormComponent extends FormBaseComponent<any> implements OnInit {

  constructor() {
    super();
  }

  ngOnInit() {
    this.init();
  }


  template(){
    this.form.addControl('currentMOP', new FormControl());
    this.form.addControl('worstMOP', new FormControl());
    this.form.addControl('totalPayment', new FormControl());

    this.form.addControl('mop1', new FormGroup({
      'originalAmount': new FormControl(),
      'balance': new FormControl(),
      'monthlyPayment': new FormControl(),
      'mop': new FormControl(),
    }))
    this.form.addControl('mop2', new FormGroup({
      'originalAmount': new FormControl(),
      'balance': new FormControl(),
      'monthlyPayment': new FormControl(),
      'mop': new FormControl(),
    }))
    this.form.addControl('mop3', new FormGroup({
      'originalAmount': new FormControl(),
      'balance': new FormControl(),
      'monthlyPayment': new FormControl(),
      'mop': new FormControl(),
    }))
    this.form.addControl('mop4', new FormGroup({
      'originalAmount': new FormControl(),
      'balance': new FormControl(),
      'monthlyPayment': new FormControl(),
      'mop': new FormControl(),
    }))
  }

}



// WEBPACK FOOTER //
// ./src/app/form/form/buro-form/buro-form.component.ts